import { useQuery } from '@tanstack/react-query';
import { Card, Group, Text, Center, Loader } from '@mantine/core';
import { Star } from 'lucide-react';
import { gameExtrasApi } from '../../api';
import { Leaderboard } from '../Leaderboard';
import { Eyebrow } from '../Eyebrow';

const STRATEGY_NOTE: Record<string, string> = {
  classic: '1 hlas na skupinu',
  per_group: 'vítěz každé skupiny',
};

export function MvpCard({ gameUuid }: { gameUuid: string }) {
  const q = useQuery({
    queryKey: ['mvp', gameUuid],
    queryFn: () => gameExtrasApi.getMvpVotes(gameUuid),
  });

  if (q.isLoading) return <Card><Center h={80}><Loader size="sm" /></Center></Card>;
  // Epocha může mít MVP vypnuté — pak kartu vůbec neukazujeme.
  if (q.error || !q.data || q.data.strategy === 'none' || q.data.votes.length === 0) return null;

  return (
    <Card padding={0}>
      <Group p="sm" gap={8} style={{ borderBottom: '1px solid var(--mantine-color-default-border)' }}>
        <Star size={15} color="var(--mantine-color-yellow-6)" />
        <Text fw={700} fz="sm" style={{ flex: 1 }}>MVP hlasování</Text>
        <Eyebrow>{STRATEGY_NOTE[q.data.strategy] ?? q.data.strategy}</Eyebrow>
      </Group>
      <Leaderboard
        unit="hl."
        rows={q.data.votes.map((v) => ({
          key: v.memberNumber,
          name: `${v.memberNumber} · ${v.memberName ?? 'Bez jména'}`,
          sub: v.groupName ?? undefined,
          value: v.voteCount,
          color: v.groupColor,
        }))}
      />
    </Card>
  );
}
